/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Calendar, Modal, Select } from 'antd';
import moment from 'moment';
import { apiLaunchPad } from '../../../api/apiLaunchPad';
import { isMobile } from 'react-device-detect';
import { useNavigate, Link } from 'react-router-dom';
import { useAccount } from 'wagmi';

const useDebounce = (value: string, delay: number) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(handler);
    }, [value, delay]);
    return debouncedValue;
};

const CalendarIdo = () => {
    const { address }: any = useAccount();
    const [dataListPool, setDataListPool] = useState([]);
    const [keySearch, setKeySearch] = useState("");
    const [type, setType] = useState("ALL");
    const [param] = useState({ page: 1, limit: 100 });
    const [modalDate, setModalDate] = useState<string | null>(null);
    const [currentMonth, setCurrentMonth] = useState(moment().startOf('month'));
    const navigate = useNavigate();
    const debouncedKeySearch = useDebounce(keySearch, 1000);
    const [selectedDate, setSelectedDate] = useState(moment());
    const handleSearch = (e: any) => setKeySearch(e.target.value);
    const handleChange = (value: string) => setType(value);
    const goToDetail = (slug: string) => navigate(`/launchpads/${slug}`);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let res = type === "JOINED" && address
                    ? await apiLaunchPad.getPoolJoined(address, param.page, param.limit)
                    : await apiLaunchPad.getPoolAll(param.page, param.limit, type === "ALL" ? "" : type, keySearch);

                if (res.data.code === 200) {
                    setDataListPool(res.data.data);
                }
            } catch (err) {
                console.error("Fetch error:", err);
            }
        };

        fetchData();
    }, [debouncedKeySearch, type, address]);

    const currentDate = moment();

    const cellRender = (current: any) => {
        const formattedDate = current.format("YYYY-MM-DD");

        const events = dataListPool.filter((item: any) => {

            if (type === "LIVE") {
                if (!item.start_time || !item.end_time) return false;
                const currentDay = moment(currentDate).startOf('day');
                const start = moment(item.start_time).startOf('day');
                const end = moment(item.end_time).endOf('day');
                return currentDay.isBetween(start, end, null, '[]');
            } else {

                return moment(item.start_time).format("YYYY-MM-DD") === formattedDate;
            }
        });

        if (events.length === 0) return null;

        const displayedEvents = events.slice(0, 2);

        return (
            <div className={type === "LIVE" ? "type-live" : "type-non-live"} style={{ textAlign: "center" }}>
                <ul className="calendar-ul" style={{ marginTop: "5px", marginBottom: "5px", padding: 0 }}>
                    {displayedEvents.map((event: any, index: number) => (
                        <li key={index} style={{ listStyle: "none", cursor: "pointer" }} onClick={() => goToDetail(event.slug)}>
                            <div className="box-img"><img src={event.avatar} alt="" /></div>
                            <div className="left-content">
                                <div className="time">
                                    {moment.utc(event.start_time).format("HH:mm")} - {moment.utc(event.end_time).format("HH:mm")}
                                </div>
                                <div className="title">{event.title}</div>
                            </div>
                        </li>
                    ))}
                </ul>

                {events.length > 2 && (
                    <button className="btn-view-all" onClick={() => setModalDate(formattedDate)}>View All</button>
                )}

                <Modal
                    className="modal-calendar"
                    open={modalDate === formattedDate}
                    onCancel={() => setModalDate(null)}
                    footer={null}
                >
                    <div className="list-ido-by-calendar-modal">
                        <div className="title-time">{moment(formattedDate).format('ddd, MMM DD YYYY').toUpperCase()}</div>
                        <ul className="calendar-ul mobile" style={{ marginTop: "20px" }}>
                            {events.map((event: any, index: number) => (
                                <li key={index} style={{ listStyle: "none", cursor: "pointer" }} onClick={() => goToDetail(event.slug)}>
                                    <div className="box-img"><img src={event.avatar} alt="" /></div>
                                    <div className="left-content">
                                        <div className="time">
                                            {moment.utc(event.start_time).format("HH:mm")} - {moment.utc(event.end_time).format("HH:mm")}
                                        </div>
                                        <div className="title">{event.title}</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Modal>
            </div>
        );
    };


    const cellRenderMobile = (current: any) => {
        const formattedDate = current.format("YYYY-MM-DD");
        const events = dataListPool.filter((item: any) => {

            if (type === "LIVE") {
                if (!item.start_time || !item.end_time) return false;
                const currentDay = moment(currentDate).startOf('day');
                const start = moment(item.start_time).startOf('day');
                const end = moment(item.end_time).endOf('day');
                return currentDay.isBetween(start, end, null, '[]');
            } else {

                return moment(item.start_time).format("YYYY-MM-DD") === formattedDate;
            }
        });

        if (events.length === 0) return null;

        return (
            <div className={type === "LIVE" ? "type-live-m" : "type-non-live-m"} style={{ textAlign: "center" }}>
                {events.length > 0 ?
                    <>
                        <ul className="calendar-dots" style={{ marginTop: "5px", marginBottom: "5px", padding: 0 }}>
                            <li style={{ listStyle: "none", cursor: "pointer" }}>
                                <div className="dots-calendar"></div>
                            </li>
                        </ul>
                    </>
                    :
                    <>
                        {""}
                    </>
                }
            </div>
        );
    };


    const CalendarList = ({ selectedDate, dataListPool }: any) => {
        const [showAll, setShowAll] = useState(false);
        const filteredData = dataListPool.filter((event: any) => {
            if (type === "LIVE") {
                if (!event.start_time || !event.end_time) return false;
                const currentDay = moment(currentDate).startOf('day');
                const start = moment(event.start_time).startOf('day');
                const end = moment(event.end_time).endOf('day');

                return currentDay.isBetween(start, end, null, '[]');
            } else {
                return moment(event.start_time).format('YYYY-MM-DD') === selectedDate.format('YYYY-MM-DD');
            }
        });

        const groupedEvents = Object.entries(
            filteredData.reduce((acc: any, event: any) => {
                const dayKey = moment(event.start_time).format('YYYY-MM-DD');
                if (!acc[dayKey]) acc[dayKey] = [];
                acc[dayKey].push(event);
                return acc;
            }, {})
        );

        const displayedGroups = showAll ? groupedEvents : groupedEvents.slice(0, 2);

        return (
            <div className={filteredData?.length > 0 ? "list-ido-by-calendar" : "list-ido-by-calendar none"}>
                <ul className="calendar-ul mobile" style={{ marginTop: "20px" }}>
                    {displayedGroups.map(([dayKey, events]: any, groupIndex) => (
                        <div key={groupIndex}>
                            <div className="title-time">{moment(dayKey).format('ddd, MMM DD YYYY').toUpperCase()}</div>
                            {events.map((event: any, index: number) => (
                                <li key={index} style={{ listStyle: "none", cursor: "pointer" }} onClick={() => goToDetail(event.slug)}>
                                    <div className="box-img"><img src={event.avatar} alt="" /></div>
                                    <div className="left-content">
                                        <div className="time">
                                            {moment.utc(event.start_time).format("HH:mm")} - {moment.utc(event.end_time).format("HH:mm")}
                                        </div>
                                        <div className="title">{event.title}</div>
                                    </div>
                                </li>
                            ))}
                        </div>
                    ))}

                    {groupedEvents.length > 2 && !showAll && (
                        <div className="view-all" onClick={() => setShowAll(true)} style={{ cursor: 'pointer', marginTop: '10px', textAlign: 'center' }}>
                            View All
                        </div>
                    )}
                </ul>
            </div>
        );
    };


    const options = [
        { value: 'ALL', label: 'All' },
        { value: 'UPCOMING', label: 'Upcoming' },
        { value: 'LIVE', label: 'Live' },
        { value: 'END', label: 'Completed' },
        { value: 'JOINED', label: 'Joined', disabled: !address }
    ];

    const filteredOptions = address ? options : options.filter(option => option.value !== 'JOINED');


    return (
        <div className="main-calendar-ido">
            <div className="container">
                <div className="wrap-calendar">
                    <div className="breadcrum-calendar">
                        <div className="item"><Link to="/launchpads">Launchpad</Link></div>
                        <div className="item res">{">"}</div>
                        <div className="item active">Calendar</div>
                    </div>

                    <div className="filter-page">
                        <div className="title">Calendar View <span>(Time Zone: UTC)</span></div>
                        <div className="search-input">
                            <input type="text" onChange={handleSearch} placeholder="Search by project name..." className="f-search" />
                            <div className="icon"><img src="./images/icon-search.png" alt="" /></div>
                        </div>
                    </div>

                    <div className={type === "LIVE" ? "view-calendar type-calendar" : "view-calendar"}>
                        <div className="line-calendar"><img src="./images/line-calendar.png" alt="" /></div>
                        <Calendar
                            className="custom-calendar"
                            cellRender={isMobile ? cellRenderMobile : cellRender}
                            onChange={(date: any) => setCurrentMonth(date.clone().startOf('month'))}
                            onPanelChange={(date: any) => setCurrentMonth(date.clone().startOf('month'))}
                            onSelect={(date: any) => setSelectedDate(date)}
                        />

                        <div className="filter-page">
                            <div className="select-sort">
                                <div className="txt">Sort by:</div>
                                <Select
                                    defaultValue="ALL"
                                    style={{ width: 180 }}
                                    onChange={handleChange}
                                    className="ant-select-raw"
                                    options={filteredOptions}
                                />
                            </div>
                        </div>
                    </div>

                    {isMobile && <CalendarList selectedDate={selectedDate} dataListPool={dataListPool} />}
                </div>
            </div>
        </div>
    );
};

export default CalendarIdo;
